module.exports = __webpack_public_path__ + "static/img/Mackenzie-Arnold.41ea979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mackenzie-Arnold.jpg
// module id = Cf57
// module chunks = 0